import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueMask from 'v-mask';
import { App, plugin } from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';
import { InertiaForm } from 'laravel-jetstream';
import PortalVue from 'portal-vue';
import VueI18n from 'vue-i18n';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlayCircle } from "@fortawesome/free-regular-svg-icons";
import { faWallet, faSpinner, faExclamationTriangle, faArrowRight, faTimes, faUser, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import messages from '../Shared/translations';
import { currency } from '@/Shared/filters/currency';
import {formatDate, formatDateTime} from '@/Shared/filters/datetime';
import Layout from './Layout';
import GuestLayout from './GuestLayout';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueCarousel from 'vue-carousel';
import InfoScreen from './Components/InfoScreen';
import bugsnagInit from '../Shared/bugsnag';
import pusherInit from '../Shared/pusher';
import credLoad from '../Shared/credmanager';

credLoad.then(credMgr => {
window.credManager = credMgr

pusherInit();

if (process.env.MIX_APP_ENV === 'production') {
    bugsnagInit();
}

library.add(
    faPlayCircle,
    faSpinner,
    faWallet,
    faExclamationTriangle,
    faArrowRight,
    faTimes,
    faMobileAlt,
    faUser,
);
Vue.component(VueQrcode.name, VueQrcode);
Vue.mixin({methods: {route}});
Vue.use(plugin);
Vue.use(InertiaForm);
Vue.use(VueMask);
Vue.use(PortalVue);
Vue.use(VueI18n);
Vue.use(VueMeta);
Vue.use(VueCarousel);
if (!window.currency) {
    console.error('There is no currency set in global scope `window.currency`');
}
Vue.filter('currency', currency(window.currency));
Vue.filter('date', formatDate);
Vue.filter('datetime', formatDateTime);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('InfoScreen', InfoScreen);

InertiaProgress.init();

const browserLang = navigator.language.split('-')[0];
const i18n = new VueI18n({
    locale: browserLang === 'pt' ? 'br' : browserLang,
    fallbackLocale: 'en',
    messages,
});

const terminal = document.getElementById('app');

new Vue({
    i18n,
    metaInfo: {
        title: window.terminalTitle ?? '',
        titleTemplate: (title) => window.terminalTitle ? window.terminalTitle : title ? `${title} - ${window.appName}` : window.appName
    },
    render: (h) =>
        h(App, {
            props: {
                initialPage: JSON.parse(terminal.dataset.page),
                resolveComponent: (name) => {
                    const page = require(`./Pages/${name}`).default;
                    if (name !== 'Lobby') {
                        page.layout = page.layout === undefined ? Layout : page.layout;
                    }

                    if (name === 'Registration' || name === 'Play' || name === 'Screen' || name === 'TerminalLogin') {
                        page.layout = GuestLayout;
                    }

                    return page;
                }
            },
        }),
}).$mount(terminal);

});
